var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"SCHOOL OPERATIONS","title":"Events Management","description":"Plan school activities, sports, competitions and excursions.","count-label":"event tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }